/* ==========================================================================
   Provider status pill (Active / Invited / Disabled)
   Shared by the Providers list and the provider details page (PORTAL-74).
   ========================================================================== */

import { ProviderStatus } from '@/api/types'

export function ProviderStatusBadge({ status }: { status: ProviderStatus }) {
  switch (status) {
    case ProviderStatus.ACTIVE:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          Active
        </span>
      )
    case ProviderStatus.INVITED:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          Invited
        </span>
      )
    case ProviderStatus.DISABLED:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
          Disabled
        </span>
      )
    default:
      return null
  }
}

export default ProviderStatusBadge
